<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
    >
      <v-card-title>
        <span class="headline">Worker</span>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <r-worker-kind label="Name:" :model.sync="model.kind" :skip-none="true"/>
          </v-col>
          <v-col cols="12">
            <v-text-field label="Level:" v-model.number="model.level" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>

      <div class="resize-handle" @mousedown.stop.prevent="startResize"/>
    </v-card>
  </v-dialog>
</template>

<script>
import { ViewRules } from "@/common/ViewRules";
import { WorkerKey } from "@/modules/redactor/models/worker/WorkerKey";
import RWorkerKind from "@/modules/redactor/views/worker/r-worker-kind";

export default {
  name: "r-worker-dialog",
  components: { RWorkerKind },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new WorkerKey(),
    rules: ViewRules.READONLY,

    dialogWidth: 288,
    minWidth: 220,

    resizing: false,
    startX: 0,
    startWidth: 0
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorkerKey();
      this.dialogWidth = 250;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid() && !this.model.isNone()) {
        this.resolve && this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject && this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },

    startResize(e) {
      this.resizing = true;
      this.startX = e.clientX;
      this.startWidth = this.dialogWidth;

      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const delta = e.clientX - this.startX;
      let next = this.startWidth + delta;

      if (next < this.minWidth) next = this.minWidth;

      this.dialogWidth = next;
    },
    stopResize() {
      if (!this.resizing) return;

      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
}

.resize-handle {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>